export default [
  {
    path: '/Personnel',
    name: 'Personnel',
    component: () => import('Components/Recruitment/content/Personnel'),
  },
]
